import i18n from "../../i18n";
import axios from "axios";

const actions = {
  login(context, loginData) {
    return axios
      .post("login", loginData)
      .then((r) => {
        //set token
        localStorage.setItem("token", r.data.token);
        //set token to axios
        axios.defaults.headers.common["Authorization"] = r.data.token;
        //get user info after 1s timeot
        setTimeout(function () {
          context.dispatch("getUserInfo");
        }, 1000);
        return r.data;
      })
      .catch((err) => {
        context.dispatch("triggerError", err);
        return false;
      });
  },
  register(context, registerData) {
    return axios
      .post("register", registerData)
      .then(function () {
        return true;
      })
      .catch(function (e) {
        //react with individual error message on douplicate email
        if (
          e.response.data.message ===
          "Something went wrong Error Code 300, try using another email"
        ) {
          context.dispatch("triggerUniversalAlert", {
            text: i18n.t("snackbars.emailNotAvailableText"),
            heading: i18n.t("snackbars.emailNotAvailableHeading"),
            type: "warning",
          });
        } else {
          //normal error
          context.dispatch("triggerError", e);
        }
        return false;
      });
  },

  confirmRegistration(context, token) {
    return axios
      .post("register/confirm", { token })
      .then(function () {
        return true;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
        return false;
      });
  },

  getUserInfo(context) {
    return axios
      .get("info")
      .then(function (r) {
        //set data
        localStorage.setItem("userData", JSON.stringify(r.data));
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  resetPassword(context, postData) {
    return axios
      .post("reset", postData)
      .then(function (r) {
        context.dispatch("triggerUniversalAlert", {
          text: i18n.t("snackbars.passwordResetSentText"),
          heading: i18n.t("snackbars.passwordResetSentHeading"),
          type: "info",
        });
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  setNewPassword(context, postData) {
    return axios
      .post("reset/" + postData.id, postData)
      .then(function (r) {
        //don't expect answer for sec reasons
        context.dispatch("triggerUniversalAlert", {
          text: i18n.t("snackbars.passwordChangedText"),
          heading: i18n.t("snackbars.passwordChangedHeading"),
          type: "info",
        });
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
};

export default actions;
